export default "__VITE_ASSET__CXu3fXeQ__"